import { render, staticRenderFns } from "./ArchiveReserves.vue?vue&type=template&id=0b65acb4&"
import script from "./ArchiveReserves.vue?vue&type=script&lang=js&"
export * from "./ArchiveReserves.vue?vue&type=script&lang=js&"
import style0 from "./ArchiveReserves.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ArchiveReserves.vue"
export default component.exports